import {Session} from "../../models/Session";
import ViewTypes from "../../enums/ViewTypes";
import NotificationManager from "../../notifications/NotificationManager";

export  default {
    session: new Session({}),
    view: ViewTypes.indicator,
    socket: null,
    notificationManager: new NotificationManager(),
    reconnectTimeout: 0,
    tokenFetching: false,
    client: null,
    mode: 'icon'
}